import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loadProfile } from "../auth/auth-session";
import { useAuth } from "../auth/AuthContext";
import { TEACHER_TRIAL_SUMMARY } from "../marketing/teacher-billing-copy";
import { TEACHER_SELF_SERVICE_SIGNUP_ENABLED } from "../auth/signup-intent";

export function TryTeachingUpgrade({ className }: { className?: string }) {
  const { setRole } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!TEACHER_SELF_SERVICE_SIGNUP_ENABLED) return null;

  return (
    <section className={className ?? "panel student-try-teaching"}>
      <h2 className="panel-title">Want to teach your own class?</h2>
      <p className="muted">{TEACHER_TRIAL_SUMMARY}</p>
      {error ? (
        <div className="warn-banner" role="alert">
          {error}
        </div>
      ) : null}
      <div className="actions" style={{ marginTop: "0.85rem" }}>
        <button
          type="button"
          className="btn secondary"
          disabled={busy}
          onClick={() => {
            void (async () => {
              setBusy(true);
              setError(null);
              try {
                await setRole("teacher");
                const next = loadProfile();
                if (next?.role === "teacher") {
                  navigate("/teacher", { replace: true });
                }
              } catch (e) {
                setError(e instanceof Error ? e.message : "Could not start teacher trial");
              } finally {
                setBusy(false);
              }
            })();
          }}
        >
          {busy ? "Starting…" : "Try teaching"}
        </button>
      </div>
    </section>
  );
}
